var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMainBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(-575 -203.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(575 203.5)",
    fill: "#edfafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wallet",
    d: "M15.879,4.862h-9.3a2.155,2.155,0,0,1-1.6-.715,2.143,2.143,0,0,1,1.6-.716H17.31A.715.715,0,1,0,17.31,2H6.577A3.578,3.578,0,0,0,3,5.577v7.155A3.578,3.578,0,0,0,6.577,16.31h9.3a2.146,2.146,0,0,0,2.146-2.146V7.008A2.146,2.146,0,0,0,15.879,4.862Zm.715,9.3a.716.716,0,0,1-.715.715h-9.3a2.149,2.149,0,0,1-2.146-2.146V5.576a3.586,3.586,0,0,0,2.146.717h9.3a.716.716,0,0,1,.715.715Zm-1.431-3.577a.715.715,0,1,1-.715-.715A.716.716,0,0,1,15.163,10.586Z",
    transform: "translate(581.845 212.045)",
    fill: "#00baf2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMainBalance);
export default __webpack_public_path__ + "static/media/userMainBalance.28cbe42816ed98865c599b0f14f24a5f.svg";
export { ForwardRef as ReactComponent };